import { HTMLAttributes } from "react";

export enum MDSDialogChipVariant {
  Note = "note",
  Collection = "collection",
  Template = "template",
}

interface IBaseDialogChipProps extends Omit<HTMLAttributes<HTMLSpanElement>, "children"> {
  label: string;
  inline?: boolean;
}

interface MDSDialogChipPropsNote extends IBaseDialogChipProps {
  variant: MDSDialogChipVariant.Note;
}

interface MDSDialogChipPropsTemplate extends IBaseDialogChipProps {
  variant: MDSDialogChipVariant.Template;
}

interface MDSDialogChipPropsCollection extends IBaseDialogChipProps {
  variant: MDSDialogChipVariant.Collection;
  collectionId?: string;
}

export type MDSDialogChipProps =
  | MDSDialogChipPropsNote
  | MDSDialogChipPropsTemplate
  | MDSDialogChipPropsCollection;
